import styled from "styled-components";

export const container = styled.div`
    grid-area: main;
    display: flex;
    flex-direction: column;
    width: 100%;

    & .banner{
        display: flex;
        background: #FEF9F2;
        border-radius: 20px;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2rem;
        padding: 0 4rem;
        height: 12rem;

        & .container-text{
            & h1{
                color: #F58B1E;
                font: 500 4rem 'Poppins', sans-serif;
            }

            & p{
                font: 500 1.5rem 'Poppins', sans-serif;
            }
        }

        & .container-img{
            img{
                width: 12rem;
                height: auto;
                position: relative;
                bottom: 1rem;
                margin-left: 2rem;                
            }
        }
    }

    @media (max-width: 576px){
        .banner{

            .container-text{
                h1{
                    font-size: 3.5rem;
                }

                p{
                    font-size: 1.2rem;
                }

            }
            .container-img{
                img{
                    width: 12rem;
                }
            }   
        }
    }

    @media (min-width: 576px) and (max-width: 784.98px) {
        .banner{

            .container-text{
                h1{
                    font-size: 4rem;
                }

                p{
                    font-size: 1.5rem;
                }

            }
            .container-img{
                img{
                    width: 12rem;
                }
            }   
        }
    }

`